import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import NotificationSystem from "react-notification-system";

import {
  Button,
  Grid,
  Table,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Modal,
  Alert,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";
import {
  GetAllLightHouseSubCategory,
  GetAllLightHouseCategoriesWithoutPagination,
  GetAllLightHouseTemplatesWithoutPagination,
  GetAllLightHouseTemplates,
  LoginLightHouse,
  addLightHouseSubCategory,
  getSubCategoriesById,
  updateLightHouseSubCategory,
} from "Listfunction";
import Swal from "sweetalert2";
import { deleteLightHouseTemplate } from "Listfunction";
import { deleteLightHouseSubCategories } from "Listfunction";

const ViewLightHouseSubCategories = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [subCategoryList, setSubCategoryList] = useState();
  const [categoryValue, setCategoryValue] = useState();
  const [templateValue, setTemplateValue] = useState();
  const [categoryOption, setCategoryOption] = useState([]);
  const [templateOption, setTemplateOption] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [addSubCategoryModalShow, setSubCategoryModalShow] = useState(false);
  const [subCategoryTitle, setSubCategoryTitle] = useState();
  const [notifyDates, setNotifyDates] = useState();
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [subCategoryId, setSubCategoryId] = useState();
  const [subCategoryTitleError, setSubCategoryTitleError] = useState(null);
  const [categoryValueError, setCategoryValueError] = useState(null);
  const [templateValueError, setTemplateValueError] = useState(null);
  const [notifyDatesError, setNotifyDatesError] = useState(null);
  const [titleeError, setTitleError] = useState(null);
  const [bodyError, setBodyError] = useState(null);
  const [templateDataById, setTemplateDataById] = useState();
  const [typeId, setTypeId] = useState();

  let LgtToken = localStorage.getItem("lightHouseToken");

  const loginCredentials = {
    email: "umar@gmail.com",
    password: "12345",
  };

  useEffect(() => {
    // ;
    // getDetaisl();

    GetAllLightHouseSubCategory(LgtToken, currentPage)
      .then((res) => {
        if (res) setCurrentPage(res.data.first_page_url);
        setTotalPage(res.data.last_page);
        setSubCategoryList(res.data.data);
        setLoading(false);
      })
      .catch(async (err) => {
        if (err.response.status === 401) {
          const res = await LoginLightHouse(loginCredentials);
          localStorage.setItem("lightHouseToken", res.data.token);
        } else {
          console.log(err);
        }
      });

    GetAllLightHouseCategoriesWithoutPagination(LgtToken)
      .then((res) => {
        setCategoryList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    GetAllLightHouseTemplatesWithoutPagination(LgtToken)
      .then((res) => {
        setTemplateList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleCategoryOnChange = (value) => {
    setCategoryValue(value);
  };
  const handleTemplateOnChange = (value) => {
    setTemplateValue(value);
  };

  const handleSubCategoryOnchange = (e) => {
    setSubCategoryTitleError(null);
    setSubCategoryTitle(e.target.value);
  };

  const handleNotifyDatesOnchange = (e) => {
    const { value } = e.target;
    const re = /^[0-9]*$/;
    if (e.target.name == "notifyDates") {
      if (re.test(value) === true) {
        setNotifyDates(value);
        setNotifyDatesError(null);
      } else {
        setNotifyDatesError(
          <small className="text-danger">
            Please enter the Positive whole number.
          </small>
        );
      }
    }
  };

  const handleAddSubCategorySubmit = async () => {
    if (subCategoryTitle === undefined) {
      setSubCategoryTitleError(
        <div className="alert alert-danger" role="alert">
          Title is Required
        </div>
      );
    } else if (categoryValue === undefined) {
      setCategoryValueError(
        <div className="alert alert-danger" role="alert">
          Category is Required
        </div>
      );
    } else if (templateValue === undefined) {
      setTemplateValueError(
        <div className="alert alert-danger" role="alert">
          Template is Required
        </div>
      );
    } else if (notifyDates === undefined) {
      setNotifyDatesError(
        <div className="alert alert-danger" role="alert">
          Notify Date is Required
        </div>
      );
    } else if (!isUpdateModal) {
      setSubCategoryTitleError(null);
      setCategoryValueError(null);
      setTemplateValueError(null);
      const addSubCategoryBody = {
        title: subCategoryTitle,
        category_id: categoryValue.value,
        notify_dates: notifyDates,
        template_id: templateValue.value,
        status: true,
      };
      const notification = _notificationSystem.current;
      try {
        const res = await addLightHouseSubCategory(
          addSubCategoryBody,
          LgtToken
        );
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Sub Category</b> - Created Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setSubCategoryModalShow(false);

          GetAllLightHouseSubCategory(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const subCategory = res.data.data;
              setSubCategoryList(subCategory);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log("err", err);
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } else {
      setCategoryValueError(null);
      setTemplateValueError(null);
      setTitleError(null);
      const updateLightHouseSubCategoryBody = {
        title: subCategoryTitle,
        category_id: categoryValue.value,
        notify_dates: notifyDates,
        template_id: templateValue.value,
        status: true,
      };
      const notification = _notificationSystem.current;
      try {
        const res = await updateLightHouseSubCategory(
          updateLightHouseSubCategoryBody,
          subCategoryId,
          LgtToken
        );
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Template</b> - Updated Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setSubCategoryModalShow(false);

          GetAllLightHouseSubCategory(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const subCategory = res.data.data;
              setSubCategoryList(subCategory);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log("err", err);
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };

  const openEditCategoryModal = (id) => {
    categoryList.map((item) => {
      categoryOption.push({
        value: item.id,
        label: item.title,
      });
    });

    templateList.map((template) => {
      templateOption.push({
        value: template.id,
        label: template.title,
      });
    });

    setSubCategoryModalShow(true);
    setIsUpdateModal(true);
    setSubCategoryId(id);

    getSubCategoriesById(LgtToken, id)
      .then((res) => {
        const subCategories = res.data;
        setSubCategoryTitle(res.data.title);
        setNotifyDates(res.data.notify_dates);
        const updatecategoryOption = categoryList.find(
          (item) => res.data.category_id === item.id
        );
        setCategoryValue({
          value: updatecategoryOption.id,
          label: updatecategoryOption.title,
        });
        const updateTemplateOption = templateList.find(
          (item) => res.data.template_id === item.id
        );
        setTemplateValue({
          value: updateTemplateOption.id,
          label: updateTemplateOption.title,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    setSubCategoryTitleError(null);
    setCategoryValueError(null);
    setTemplateValueError(null);
    setNotifyDatesError(null);
  };

  const handleAddCaddCategoryButtonClick = () => {
    setSubCategoryModalShow(true);

    categoryList.map((item) => {
      categoryOption.push({
        value: item.id,
        label: item.title,
      });
    });

    templateList.map((template) => {
      templateOption.push({
        value: template.id,
        label: template.title,
      });
    });

    setIsUpdateModal(false);
    setSubCategoryTitle(undefined);
    setCategoryValue(undefined);
    setTemplateValue(undefined);
    setNotifyDates(undefined);
    setSubCategoryTitleError(null);
    setCategoryValueError(null);
    setTemplateValueError(null);
    setNotifyDatesError(null);
  };

  const handleRemoveClick = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to remove this sub category </font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const notification = _notificationSystem.current;
        const res = await deleteLightHouseSubCategories(LgtToken, id);
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Template</b> - Removed Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setLoading(true);
          GetAllLightHouseSubCategory(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const subCategory = res.data.data;
              setSubCategoryList(subCategory);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  };

  const paginationOnChange = async (LgtToken, number) => {
    setLoading(true);
    const res = await GetAllLightHouseSubCategory(LgtToken, number);

    setSubCategoryList(res.data.data);
    setCurrentPage(res.data.current_page);
    setTotalPage(res.data.last_page);
    setLoading(false);
  };

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => paginationOnChange(LgtToken, number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  const remove = <Tooltip id="remove">Remove</Tooltip>;
  const edit = <Tooltip id="edit">Edit</Tooltip>;

  return (
    <>
      <Grid fluid>
        <Col xs={12} sm={12} md={12} lg={12}>
          <NotificationSystem ref={_notificationSystem} />
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} className="text-left">
              <FormControl
                style={{ position: "relative", marginTop: "25px" }}
                name="search"
                //   value={searchParam}
                placeholder="Search"
                //   onChange={(event) => handleSearch(event)}
                type="text"
                className="text-input"
              />
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} className="text-left">
              <Button
                style={{ marginTop: "25px" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              >
                Reset
              </Button>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} className="text-right">
              <Button
                style={{ marginTop: "25px" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                onClick={() => handleAddCaddCategoryButtonClick()}
              >
                Add Sub Category <i className="fa fa-plus"></i>
              </Button>
              <br />
              &nbsp;
            </Col>
          </Row>
        </Col>
        <br />
        <Col md={12}>
          <Card
            content={
              <>
                <React.Fragment>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Sub Category</th>
                        <th>Category</th>
                        <th>Template</th>
                        <th>Screen link</th>
                        <th>Content</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td>
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : noRecordFound ? (
                        <tr>
                          <td colspan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {subCategoryList &&
                            subCategoryList.map((item, i) => (
                              <>
                                <tr>
                                  <td>{item.id}</td>
                                  <td>
                                    {item.title === null ? "-" : item.title}
                                  </td>
                                  <td>
                                    {item.category.title === null
                                      ? "-"
                                      : item.category.title}
                                  </td>
                                  <td>
                                    &nbsp;
                                    {item.template === null
                                      ? ""
                                      : item.template.title === null
                                      ? "-"
                                      : item.template.title}
                                  </td>
                                  <td>
                                    {item.template === null
                                      ? ""
                                      : item.template.type_name === null
                                      ? "-"
                                      : item.template.type_name}
                                  </td>
                                  <td>
                                    {item.template === null
                                      ? ""
                                      : item.template.body === null
                                      ? "-"
                                      : item.template.body}
                                  </td>

                                  <td className="td-actions text-right no-padding">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple="true"
                                        bsStyle="info"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                          openEditCategoryModal(item.id);
                                        }}
                                      >
                                        <i className="fa fa-pencil" />
                                      </Button>
                                    </OverlayTrigger>
                                    &nbsp;
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={remove}
                                    >
                                      <Button
                                        simple="true"
                                        bsStyle="danger"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                          handleRemoveClick(item.id);
                                        }}
                                      >
                                        <i className="fa fa-times" />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              </>
                            ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination bsSize="medium">{items}</Pagination>
                  </div>
                </React.Fragment>
              </>
            }
          />
        </Col>
      </Grid>
      <Modal
        show={addSubCategoryModalShow}
        onHide={() => setSubCategoryModalShow(false)}
        bsSize="large"
        allowFullScreen
      >
        <Modal.Header>
          <Modal.Title>
            {isUpdateModal ? "Edit Sub Category" : "Add Sub Category"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Sub Category Title</ControlLabel>
              <FormGroup>
                <FormControl
                  type="text"
                  value={subCategoryTitle}
                  name="type"
                  placeholder="Enter the Type name "
                  onChange={(e) => handleSubCategoryOnchange(e)}
                />
              </FormGroup>
              {subCategoryTitleError}
            </Col>
          </Row>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Category</ControlLabel>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="Category"
                  placeholder="Select Category"
                  value={categoryValue}
                  options={categoryOption}
                  onChange={(value) => handleCategoryOnChange(value)}
                />
              </FormGroup>
              {categoryValueError}
            </Col>
          </Row>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Template</ControlLabel>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="templateError"
                  placeholder="Select Template"
                  value={templateValue}
                  options={templateOption}
                  onChange={(value) => handleTemplateOnChange(value)}
                />
              </FormGroup>
              {categoryValueError}
            </Col>
          </Row>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Notify Dates</ControlLabel>
              <FormGroup>
                <FormControl
                  type="text"
                  name="notifyDates"
                  placeholder="Enter the Notify Dates "
                  onChange={(e) => handleNotifyDatesOnchange(e)}
                  value={notifyDates}
                />
              </FormGroup>
              {notifyDatesError}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="danger"
            onClick={() => setSubCategoryModalShow(false)}
          >
            Cancel
          </Button>
          <Button
            bsStyle="success"
            onClick={() => handleAddSubCategorySubmit()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewLightHouseSubCategories;
